import React from 'react'
import { Table, TableBody, TableCell, TableContainer,TableHead, TableRow, Paper, Box, Grid, CardMedia, Typography, Button, ButtonGroup, Backdrop, CircularProgress, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Checkbox, Alert, AlertTitle } from '@material-ui/core';
import { Link as DomLink, useNavigate } from 'react-router-dom';
import { Delete } from '@material-ui/icons';
import './CartTable.css';
import axios from "axios";
// import {config} from "../../config/config";
import {config} from "../../config/config";
import Cookies from "universal-cookie";
import { CartContext } from '../CartContext/CartContext';
import ApiQuery from "../utils/apiQuery/apiQuery";
import ProductPurchaseInfo from '../ProductPurchaseInfo/ProductPurchaseInfo';
import { getPurchaseRules } from '../ProductPurchaseInfo/productPurchase';
import { validateCart } from '../Cart/cartRules';
import fallbackImage from '../../assets/sin_imagen.jpg';
// import ItemClass from '../utils/ItemClass/ItemClass';
let apiQuery = new ApiQuery();
// let itemClass = new ItemClass();

const cookies = new Cookies();

function currencyFormat(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) {
    return String(value || '').trim().toLowerCase() === 'no disponible'
      ? 'No disponible'
      : (typeof value === 'string' ? value : 'No disponible');
  }
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 2,
  }).format(number);
}
function ccyFormatOne(num) {
  let numFloat = parseFloat(num)
  return Number.isFinite(numFloat) ? `${numFloat.toFixed(1)}` : 'No informado';
      }

function ivaFormat(value) {
  const percentage = ccyFormatOne(parseFloat(typeof value === "string" ? value.replace(/,/g, '.').replace(/%/g, '') : value));
  return percentage === 'No informado' ? 'IVA no informado' : `${percentage}% IVA`;
}
    

const token = cookies.get("token");

// let dolar = config.DOLAR;


function capitalizeFirstLetter(string) {
  let cadena = String(string || '').trim().toLowerCase()
  if (!cadena) return '';
  return cadena.charAt(0).toUpperCase() + cadena.slice(1);
}

function resolveCartImage(imageName) {
  if (!imageName || imageName === 'sin_imagen.jpg') return fallbackImage;
  if (/^https?:\/\//i.test(imageName)) return imageName;
  return `${config.SERVER}/images/${imageName}`;
}

const CartTable = ({cart, removeFromCart, updateCartQuantity, total, ivaTotal}) => {
  const [isAdmin, setIsAdmin] = React.useState(false)
  const [listaUsuarios, setListaUsuarios] = React.useState([])
  const [usuario, setUsuario] = React.useState('');
  const descuento = '';
  const [errorMessage, setErrorMessage] = React.useState('');
	const cartContext = React.useContext(CartContext);
  const itemClass = cartContext.itemClassContext;
	const {changeUser, cleanCart, IdVendedor}= cartContext;
	// Backdrop or Loading spinner 
  const [open, setOpen] = React.useState(false);
  const submittingRef = React.useRef(false);
  const mountedRef = React.useRef(true);
  const [dolar, setDolar] = React.useState(0)
  const [presupuesto, setPresupuesto] = React.useState(false);
  const [expandedRows, setExpandedRows] = React.useState({});
  const validationErrors = validateCart(cart);

  const toggleExpanded = (rowId) => {
    setExpandedRows(prev => ({
      ...prev,
      [rowId]: !prev[rowId]
    }));
  };

  let navigate = useNavigate();

  function calcularPrecio(precioConIva,iva,precio,usd,qty,oferta,precioOferta,disponibilidad) {
    // let price = (oferta && oferta=="si" && precioOferta) ? ccyFormat(precioOferta) : precio
    // // let resultado = (precioConIva ? parseFloat(precioConIva)/(1+(parseFloat(typeof iva === "string" ? iva.replace(/,/g, '.').replace(/%/g, '') : iva))/100) : (price ? `${price}` : usd*dolar))*(qty ? parseFloat(qty) : 1);
    // let resultado = (precioConIva ? parseFloat(precioConIva)/(1+(parseFloat(typeof iva === "string" ? iva.replace(/,/g, '.').replace(/%/g, '') : iva))/100) : ((usd && usd != 0) ? usd*dolar : `${price}`))*(qty ? parseFloat(qty) : 1);
    // return ccyFormat(resultado)

    return(itemClass.calcularPrecioCantidad(precioConIva,iva,precio,usd,qty,oferta,precioOferta,dolar,disponibilidad))
  }

  const handleOrden = async () => {
    if (submittingRef.current || validationErrors.length > 0 || cart.length === 0) return;
    submittingRef.current = true;
    setOpen(true)
    setErrorMessage('');

    let configuration;

    if (usuario!=='') {
      // console.log(`cliente seleccionado`);
      // console.log(usuario);
      // console.log(`presupuesto: ${presupuesto}`);
      configuration = {
        method: "post",
        // Enviar por parametros si se trata de un presupuesto o una orden
        url: `${config.SERVER}/api/order/user${presupuesto ? '?presupuesto=si' : ''}`,
        // url: `${config.SERVER}/api/order/user`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: usuario,
        withCredentials: true,
      }
    } else {
      // console.log(`sincliente`);
      configuration = {
        method: "post",
        url: `${config.SERVER}/api/order`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true, 
      }
    }

    try {
      const result = await axios(configuration);
      await cleanCart();
      navigate(`/alert/${result.data.ordenId}`, { replace: true });
    } catch (error) {
      setErrorMessage('No pudimos enviar el pedido. Tu carrito se conservó para que puedas intentarlo nuevamente.');
    } finally {
      submittingRef.current = false;
      if (mountedRef.current) setOpen(false);
    }
  }

  React.useEffect(() => () => {
    mountedRef.current = false;
  }, []);

  React.useEffect(() => {
    let active = true;
    apiQuery.get(`/api/dolar`)
		.then((respuesta) => {
      if (active && respuesta && respuesta.dolar) {
        setDolar(Number(respuesta.dolar));
      }
		})
		.catch(() => {});
    return () => { active = false; };
  }, [])

  React.useEffect(() => {
    let active = true;
    apiQuery.get(`/permisos/nivel`)
    .then((respuesta)=>{
      if (!active) return;
      setIsAdmin(respuesta)
      if (respuesta) {
        apiQuery.get(`/api/users`)
        .then((res)=>{
          if (!active) return;
          // let listaFiltrada =  res.filter((item)=> item.vendedor.match(new RegExp(`${IdVendedor}`,'gi')))
          // setListaUsuarios(listaFiltrada)
          setListaUsuarios(res)
        })
      }
    })
    return () => { active = false; };
  }, [IdVendedor])

  //   React.useEffect(() => {
  //     if (usuario) {
  //       apiQuery.get(`/descuento?email=${usuario.email}`)
  //       .then((respuesta)=>{
  //         setDescuento(respuesta)
  //       })
  //     } else {
  //       apiQuery.get(`/descuento?email=${user}`)
  //       .then((respuesta)=>{
  //         setDescuento(respuesta)
  //       }) 
  //     }
  // }, [usuario])
  
// React.useEffect(() => {

// console.log(cart);
// }, [])


  const handleUsuario = (event) => {
    setUsuario(event.target.value);
    changeUser(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  }

	return (
    <>
      <TableContainer component={Paper} sx={{ marginTop: "1rem", flex:'40%', maxWidth: '100%' }}>
        <Table className="table" aria-label="Productos incluidos en el pedido" sx={{pr:"0px"}}>
          <TableHead>
            {/* <TableRow>
              <TableCell align="center" colSpan={4}>
                Details
              </TableCell>
              <TableCell align="right">Price</TableCell>
            </TableRow> */}
            <TableRow>
              <TableCell align="center" sx={{pr:"0px"}}>Producto</TableCell>
              <TableCell align="center" sx={{pr:"0px"}}>Quitar</TableCell>
              <TableCell align="center" sx={{pr:"0px"}}>Cantidad</TableCell>
              <TableCell align="center" sx={{pr:"0px"}}>Precio unitario</TableCell>
              <TableCell align="center">Subtotal</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cart.map((row, rowIndex) => (
              <TableRow key={row._id ? row._id : row.id}>
                <TableCell align="right" sx={{pr:"0px"}}
                  // sx={{
                  //   fontSize: 16,
                  //   // mt: 1,
                  //   m:0,
                  //   p:0,
                  //   width: "100%",
                  //   display: "flex",
                  //   flexDirection: "column",
                  //   justifyContent: "left",
                  //   alignItems: "center",
                  // }}
                >
                  <DomLink to={`/detail/${row._id ? row._id : row.id}`} style={{textDecoration: "none"}}>
                  <Box
                    component="span"
                    sx={{
                      fontSize: 12,
                      // m:0,
                      // p:0,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign:'center',
                      maxWidth:"250px",
                      margin:"auto"
                    }}
                  >
                    <Box>
                    <CardMedia
                      component="img"
                      image={resolveCartImage(row.image)}
                      onError={(event) => {
                        event.currentTarget.onerror = null;
                        event.currentTarget.src = fallbackImage;
                      }}
                      alt={row.name || `Producto ${row.code || ''}`}

                      sx={{ height: {xs:60, sm:90}, marginBottom: "1rem" }}
                    />
                    </Box>
                    <Typography sx={{textDecoration: "none", fontSize:{xs:"x-small",sm:"small",md:"medium"}}} color="text.primary" variant="caption">
                      {
                        (() => {
                          const longText = `${capitalizeFirstLetter(`${
                            [row.name,
                             row.color,
                             row.linea,
                             row.presentacion,
                             `${(row.unidades !== "0" && row.lista === "buloneria bremen") ? (`${row.unidades} unidades`) : ""}`,
                             `${row.contenido ? (""+row.contenido) : ""}`,
                             `${(row.lista === "einhell") ? (row.description || "") : ""}`,
                             `${(row.lista === "einhell") ? (row.medidas || "") : ""}`
                           ].filter(Boolean).join(" | ")
                         }`)} (${row.code})`;
                          const maxLength = 100;
                          const isExpanded = expandedRows[row._id || row.id];
                          const rowId = row._id || row.id;

                          if (longText.length > maxLength) {
                            return (
                              <>
                                {isExpanded ? longText : `${longText.substring(0, maxLength)}...`}
                                <Button variant="text" size="small" onClick={(e) => {e.preventDefault(); e.stopPropagation(); toggleExpanded(rowId)}} sx={{fontSize:"x-small", display: 'block', margin: 'auto'}}>
                                  {isExpanded ? 'Leer menos' : 'Leer más'}
                                </Button>
                              </>
                            );
                          } else {
                            return longText;
                          }
                        })()
                      }
                    </Typography>                  
                    <ProductPurchaseInfo product={row} compact />
                  </Box>
                  </DomLink>
                </TableCell>
                <TableCell align="center" sx={{pr:"0px"}}>
                  <Button
                    color='error'
                    variant='contained'
                    aria-label={`Quitar ${row.name || row.code || 'producto'} del pedido`}
                    onClick={() => removeFromCart(rowIndex)}
                    sx={{minWidth:"fit-content", p:"6px"}}
                  >
                    <Delete />
                  </Button>
                </TableCell>
                <TableCell align="center" sx={{pr:"0px"}}>
                  <ButtonGroup size="small" aria-label={`Cantidad de ${row.name || row.code || 'producto'}`}>
                    <Button
                      aria-label={`Reducir cantidad de ${row.name || row.code || 'producto'}`}
                      onClick={() => updateCartQuantity(rowIndex, 'decrease')}
                      disabled={Number(row.qty) <= getPurchaseRules(row).minimum}
                    >
                      −
                    </Button>
                    <Button disabled aria-label={`Cantidad actual: ${row.qty}`}>{row.qty}</Button>
                    <Button
                      aria-label={`Aumentar cantidad de ${row.name || row.code || 'producto'}`}
                      onClick={() => updateCartQuantity(rowIndex, 'increase')}
                    >
                      +
                    </Button>
                  </ButtonGroup>
                </TableCell>
                {/* <TableCell align="center" sx={{pr:"0px"}}>{ccyFormat(row.price ? row.price : row.usd*dolar)}</TableCell> */}
                <TableCell align="center" sx={{pr:"0px"}}>
                  <Box
                      component="span"
                      sx={{
                        // fontSize: 12,
                        // m:0,
                        // p:0,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign:'center',
                        maxWidth:"250px",
                        margin:"auto"
                      }}
                    >
                      <Box>
                      {/* {ccyFormat(row.price ? row.price : row.usd*dolar)} */}
                  {/* {ccyFormat((row.precioConIva ? row.precioConIva-row.precioConIva*(parseFloat(typeof row.iva === "string" ? row.iva.replace(/,/g, '.').replace(/%/g, '') : row.iva))/100 : (row.price ? `${row.price}` : row.usd*dolar)))} */}
                  {currencyFormat(calcularPrecio(row.precioConIva,row.iva,row.price,row.usd,1,row.oferta,row.precioOferta,row.disponibilidad))}
                      </Box>
                      <Box sx={{color:"text.secondary"}}>
                      ({ivaFormat(row.iva)})
                      </Box>         
                    </Box>

                  </TableCell>
                <TableCell align="center">
                  {/* {ccyFormat((row.price ? row.price : row.usd*dolar) * row.qty)} */}
                  {/* {ccyFormat(((row.precioConIva ? row.precioConIva-row.precioConIva*(parseFloat(typeof row.iva === "string" ? row.iva.replace(/,/g, '.').replace(/%/g, '') : row.iva))/100 : (row.price ? `${row.price}` : row.usd*dolar)))*row.qty)} */}
                  {currencyFormat(calcularPrecio(row.precioConIva,row.iva,row.price,row.usd,row.qty,row.oferta,row.precioOferta,row.disponibilidad))}
                  {/* {row.precioConIva ? row.precioConIva : (row.price ? `$ ${row.price}` : "NO DISPONIBLE") } */}
                </TableCell>
              </TableRow>
            ))}

            <TableRow>
              <TableCell rowSpan={4} />
              <TableCell colSpan={3}>Subtotal</TableCell>
              <TableCell align="center">{currencyFormat(total)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={3}>IVA</TableCell>
              {/* <TableCell align="right">{``}</TableCell> */}
              <TableCell align="center">{currencyFormat(ivaTotal)}</TableCell>
            </TableRow>
            {descuento ? <>
              <TableRow>
                <TableCell colSpan={3}>Descuento ({parseFloat(descuento)}%)</TableCell>
                <TableCell align="center">- {currencyFormat(parseFloat(descuento)/100*(parseFloat(total)))}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={3}>TOTAL</TableCell>
                <TableCell align="center">{currencyFormat((parseFloat(total)+parseFloat(ivaTotal))-(parseFloat(descuento)/100*(parseFloat(total))))}</TableCell>
              </TableRow>
            </> : <>
            <TableRow>
              <TableCell colSpan={3}>TOTAL</TableCell>
              <TableCell align="center">{currencyFormat((parseFloat(total)+parseFloat(ivaTotal)))}</TableCell>
            </TableRow>            
            </>}
          </TableBody>
        </Table>
      </TableContainer>
      {validationErrors.length > 0 && (
        <Alert severity="warning" sx={{ width: '100%', mt: 2 }}>
          <AlertTitle>Revisá las cantidades antes de enviar</AlertTitle>
          <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
            {validationErrors.map(error => <li key={error}>{error}</li>)}
          </Box>
        </Alert>
      )}
      {errorMessage && (
        <Alert severity="error" sx={{ width: '100%', mt: 2 }}>
          <AlertTitle>El pedido no se envió</AlertTitle>
          {errorMessage}
        </Alert>
      )}
      {isAdmin ? <>
        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                <FormControl variant="outlined" sx={{width:"100%"}} >
                  <InputLabel id="order-client-label">Cliente</InputLabel>
                  <Select
                  fullWidth
                    labelId="order-client-label"
                    id="order-client"
                    value={usuario}
                    onChange={handleUsuario}
                    label="Cliente"
                    name="cliente"
                    sx={{width:"100%"}}
                  >
                    <MenuItem value="">
                      <em>Seleccionar cliente</em>
                    </MenuItem>
                    {listaUsuarios.sort(function (a, b) {
                      const nombreA = a.name.toLowerCase();
                      const nombreB = b.name.toLowerCase();
                      if (nombreA > nombreB) {
                        return 1;
                      }
                      if (nombreA < nombreB) {
                        return -1;
                      }
                      return 0;
                    }).map((item) => (
                      <MenuItem key={item.name} value={item}>{`${
                        [item.name,item.ferreteria].filter(Boolean).join(" - ")
                        }`}</MenuItem>
                    ))}
                  </Select>
                  {/* Checkbox para presupuesto */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={presupuesto}
                        onChange={(e) => setPresupuesto(e.target.checked)}
                        name="presupuesto"
                        color="primary"
                      />
                    }
                    label="Presupuesto"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Button sx={{ width:"100%"}} variant='contained' 
                onClick={handleOrden}
                disabled={!usuario || open || validationErrors.length > 0}
                >
                  {open ? 'Enviando…' : (presupuesto ? 'Enviar presupuesto' : 'Enviar pedido')}
                </Button>
              </Grid>
            </Grid>
        </Box>        

      </> : <>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 3, textAlign: 'center' }}>
        Revisá los productos y cantidades. El pedido no incluye pago online.
      </Typography>
      <Button sx={{my:2}} variant='contained'
      onClick={handleOrden}
      disabled={open || validationErrors.length > 0}
      >
        {open ? 'Enviando…' : 'Enviar pedido'}
      </Button>
      
      </>}

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        aria-label="Enviando pedido"
        >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <CircularProgress color="inherit" />
          <Typography>Enviando pedido…</Typography>
        </Box>
      </Backdrop>
    </>
  );
}

export default CartTable
